<script>
export default {
  name: 'TrocarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: '#030309',
    },
  },
  computed: {
    // ID único por instância (this._uid é garantido único por componente Vue) —
    // o id fixo original colide quando o ícone renderiza mais de uma vez na página.
    maskId() {
      return `mask0_5597_146956_${this._uid}`
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Icone trocar">
      <path
        id="Mask"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.80418 6.47134C4.54352 6.73201 4.12218 6.73201 3.86152 6.47134L1.86152 4.47134C1.60085 4.21067 1.60085 3.78934 1.86152 3.52867L3.86152 1.52867C3.99152 1.39867 4.16218 1.33334 4.33285 1.33334C4.50352 1.33334 4.67418 1.39867 4.80418 1.52867C5.06485 1.78934 5.06485 2.21067 4.80418 2.47134L3.94218 3.33334H11.9395C13.2595 3.33334 14.3328 4.38867 14.3328 5.68601V7.33334C14.3328 7.70201 14.0348 8.00001 13.6662 8.00001C13.2975 8.00001 12.9995 7.70201 12.9995 7.33334V5.68601C12.9995 5.12401 12.5242 4.66667 11.9395 4.66667H3.94218L4.80418 5.52867C5.06485 5.78934 5.06485 6.21067 4.80418 6.47134ZM12.0567 12.6667H4.0594C2.74007 12.6667 1.66607 11.6113 1.66607 10.314L1.66607 8.66667C1.66607 8.29801 1.96407 8.00001 2.33273 8.00001C2.7014 8.00001 2.9994 8.29801 2.9994 8.66667L2.9994 10.314C2.9994 10.8753 3.47473 11.3333 4.0594 11.3333H12.0567L11.1947 10.4713C10.9347 10.2107 10.9347 9.78934 11.1947 9.52867C11.3247 9.39867 11.4954 9.33334 11.6661 9.33334C11.8367 9.33334 12.0074 9.39867 12.1374 9.52867L14.1374 11.5287C14.3981 11.7893 14.3981 12.2107 14.1374 12.4713L12.1374 14.4713C11.8774 14.732 11.4554 14.732 11.1947 14.4713C10.9347 14.2107 10.9347 13.7893 11.1947 13.5287L12.0567 12.6667Z"
        :fill="color"
      />
      <mask
        :id="maskId"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="1"
        y="1"
        width="14"
        height="14"
      >
        <path
          id="Mask_2"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.80418 6.47134C4.54352 6.73201 4.12218 6.73201 3.86152 6.47134L1.86152 4.47134C1.60085 4.21067 1.60085 3.78934 1.86152 3.52867L3.86152 1.52867C3.99152 1.39867 4.16218 1.33334 4.33285 1.33334C4.50352 1.33334 4.67418 1.39867 4.80418 1.52867C5.06485 1.78934 5.06485 2.21067 4.80418 2.47134L3.94218 3.33334H11.9395C13.2595 3.33334 14.3328 4.38867 14.3328 5.68601V7.33334C14.3328 7.70201 14.0348 8.00001 13.6662 8.00001C13.2975 8.00001 12.9995 7.70201 12.9995 7.33334V5.68601C12.9995 5.12401 12.5242 4.66667 11.9395 4.66667H3.94218L4.80418 5.52867C5.06485 5.78934 5.06485 6.21067 4.80418 6.47134ZM12.0567 12.6667H4.0594C2.74007 12.6667 1.66607 11.6113 1.66607 10.314L1.66607 8.66667C1.66607 8.29801 1.96407 8.00001 2.33273 8.00001C2.7014 8.00001 2.9994 8.29801 2.9994 8.66667L2.9994 10.314C2.9994 10.8753 3.47473 11.3333 4.0594 11.3333H12.0567L11.1947 10.4713C10.9347 10.2107 10.9347 9.78934 11.1947 9.52867C11.3247 9.39867 11.4954 9.33334 11.6661 9.33334C11.8367 9.33334 12.0074 9.39867 12.1374 9.52867L14.1374 11.5287C14.3981 11.7893 14.3981 12.2107 14.1374 12.4713L12.1374 14.4713C11.8774 14.732 11.4554 14.732 11.1947 14.4713C10.9347 14.2107 10.9347 13.7893 11.1947 13.5287L12.0567 12.6667Z"
          fill="white"
        />
      </mask>
      <g :mask="`url(#${maskId})`">
        <g id="🎨 Color">
          <rect
            id="Base"
            y="16"
            width="16"
            height="16"
            transform="rotate(-90 0 16)"
            :fill="color"
          />
        </g>
      </g>
    </g>
  </svg>
</template>
